module.exports = __webpack_public_path__ + "img/lemsi-logo.dfe98862.svg";